import { MenuItem, RaisedButton, SelectField } from 'material-ui';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
// import { getSettingsByKey, setSettingByKey } from '../utils/localSettings';

const Pagination = ({
  data,
  itemsPerPage,
  setItemsPerPage,
  currentPage,
  setCurrentPage,
  children
}) => {
  // const [currentPage, setCurrentPage] = useState(1);
  // const [itemsPerPage, setItemsPerPage] = useState(initialItemsPerPage);

  const totalPages = useMemo(() => Math.ceil(data.length / itemsPerPage), [
    data.length,
    itemsPerPage,
  ]);
  const currentData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return data.slice(startIndex, endIndex);
  }, [data, currentPage, itemsPerPage]);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  return (
    <div>
      {children(currentData)}
      <div className="pagination" style={{ display: 'flex', justifyContent: 'end', padding: 8 }}>
        <div style={{ marginTop: 3 }}>
          <RaisedButton style={{ minWidth: 30, marginRight: 12 }} onClick={() => goToPage(currentPage - 1)}>
            {'<'}
          </RaisedButton>
          <FormattedMessage id="Pagination.TotalPages" values={{ page: currentPage, pages: totalPages }} />
          <RaisedButton style={{ minWidth: 30, marginLeft: 12 }} onClick={() => goToPage(currentPage + 1)}>
            {'>'}
          </RaisedButton>
        </div>
        <div>
          <SelectField
            style={{ marginLeft: 12, marginRight: 8, width: 140 }}
            value={itemsPerPage}
            onChange={(event, index, value) => {
              setItemsPerPage(value);
              data.length ? setCurrentPage(1) : setCurrentPage(0);
            }}
          >
            <MenuItem value={10} primaryText={<FormattedMessage id="Pagination.PerPage" values={{ items: 10 }} />} />
            <MenuItem value={20} primaryText={<FormattedMessage id="Pagination.PerPage" values={{ items: 20 }} />} />
            <MenuItem value={50} primaryText={<FormattedMessage id="Pagination.PerPage" values={{ items: 50 }} />} />
            <MenuItem value={100} primaryText={<FormattedMessage id="Pagination.PerPage" values={{ items: 100 }} />} />
          </SelectField>
        </div>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  children: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  setItemsPerPage: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/shared/Pagination.js